import React from 'react'
import prof from "./assets/prof.jpg"

function Home() {
  return (
    <div className="h-fit w-full">
        {/* pic */}
            
        <div className="bg-gradient-to-r from-[#764ABC] to-black mt-[60px]">
            {/* <div className="h-[20px] w-[100%] flex justify-between items-center pr-[7%] ml-[4%] pt-[2%] text-white">
              <p className="cursor-pointer">Logo</p>
              <div className=" flex items-center gap-5">
              <p className="cursor-pointer">Projects</p>
              <p className="cursor-pointer">Skills</p>
              <p className="cursor-pointer">Contact</p>
              <div className="w-fit h-fit rounded-xl px-6 py-2 bg-[#8c14fc] cursor-pointer">Hire me</div>

             </div>
            </div> */}
            <div className="h-full w-full  grid sm:grid items-center justify-center md:flex flex-row-reverse md:justify-between md:px-[7%] lg:pr-[20%] xl:pr-[18%] pt-14 pb-4 sm:py-6 xs:pt-[78px]">
            <div className="w-[300px] h-[300px] sm:w-[300px] sm:h-[300px] md:w-[400px] md:h-[400px]">
              <img src={prof} alt="profile" className='w-full h-full rounded-full' />
            </div>
           
           <div className='w-full md:w-fit text-white grid justify-center md:block'>
            <div className='w-fit xs:w-full text-center pt-3'>
              👋 Hello am Emmanuel<br/>
              <p className='text-center'>And</p>
              I bring Ideas to life
              </div>
            <div className='w-fit bg-white p-5 rounded-lg text-[#0d2438] my-7'>
              <p>Frontend ✔️</p>
              <p>Backend ✔️ </p>
              <p>Founder of Dev Den ✔️</p>
            </div>
           </div>
            
            </div>
            

            {/* <img src={backgroundImage} alt="" /> */}
        </div>
    </div>
  )
}

export default Home